require('./payments.scss')

module.exports = {
  template: require('./payments.pug')()
  controller: require('./payments.ctrl')
  bindings:
    salon: '<'
}
